import { CSSAttribute } from '../../types';

export const PX = (a: number | string) => a + 'px';
export const style = (elem: HTMLElement, style: CSSAttribute) => elem?.style && Object.assign(elem.style, style);

export function temporaryStyle(elem: HTMLElement, style: CSSAttribute) {
  const initialStyle = Object.keys(style).reduce((o, k) => ({ ...o, [k]: elem.style[k as any] }), {});

  Object.assign(elem.style, style);

  return () => Object.assign(elem.style, initialStyle);
}

export function highlightTags(color: string): (tag: string) => { color: string } | {} {
  return function (tag: string) {
    if (tag.match(/^@|^#|^https?:\/\//)) {
      return { color };
    }
    return {};
  };
}

export function shouldBarsBeVisible(idealWidth: number, idealHeight: number, realWidth: number, realHeight: number) {
  const barsSize = Math.max(Math.abs(realWidth - idealWidth), Math.abs(realHeight - idealHeight));

  return barsSize > 6;
}
